import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { AddRoutineButton } from "../AddRoutineButton";

interface RoutineListHeaderProps {
  onBack?: () => void;
  hideBackButton?: boolean;
  canEdit: boolean;
  planId: string;
  onAddRoutine: (routineId: string) => Promise<void>;
}

export const RoutineListHeader = ({
  onBack,
  hideBackButton,
  canEdit,
  planId,
  onAddRoutine
}: RoutineListHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
      <div className="flex flex-col gap-2">
        {!hideBackButton && onBack && (
          <Button
            variant="ghost"
            onClick={onBack}
            className="self-start hover:bg-primary/10 hover:text-primary transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver a rutinas
          </Button>
        )}
      </div>

      {canEdit && (
        <AddRoutineButton 
          onClick={onAddRoutine}
          planId={planId}
        />
      )}
    </div>
  );
};